import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
/* import LanguageDetector from 'i18next-browser-languagedetector'; */

import enTranslations from '../locales/en/common.json';
import ruTranslations from '../locales/ru/common.json';

i18n
/*   .use(LanguageDetector) */
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enTranslations,
      },
      ru: {
        common: ruTranslations,
      },
    },
    
    lng: 'ru',
    fallbackLng: 'ru',
    
    defaultNS: 'common',
    interpolation: {
      escapeValue: false
    },
    
/*     detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    }, */
  });

export default i18n; 